import React from "react";
import Farmaceuta from "../components/Farmaceuta/";

const FarmaceutaContainer = () => {
  return <Farmaceuta />;
};

export default FarmaceutaContainer;
